import router from "../router";

export function refreshPage() {
  router.go(); // Reloads the current route
}

export function redirectToContactUs() {
  if (this.$route.path !== "/contactus") {
    router.push({ path: "/contactus" });
  }
}

export function redirectToAboutUs() {
  if (this.$route.path !== "/aboutus") {
    router.push({ path: "/aboutus" });
  }
}

export function redirectToFaq() {
  if (this.$route.path !== "/newfaq") {
    router.push({ path: "/newfaq" });
  }
}

export function redirectToBlog() {
  if (this.$route.path !== "/blog") {
    router.push({ path: "/blog" });
  }
}

export function redirectToMyAccount() {
  if (this.$route.path !== "/myprofile") {
    router.push({ path: "/myprofile" });
  }
}

export function redirectToEnquire() {
  if (this.$route.path !== "/enquire") {
    router.push({ path: "/enquire" });
  }
}

export function redirectToMyFavourites() {
  if (this.$route.path !== "/myfavourites") {
    router.push({ path: "/myfavourites" });
  }
}

export function redirectToHome() {
  if (sessionStorage.searchFiltersForm) {
    let options = JSON.parse(sessionStorage.searchFiltersForm);
    options.searchSuburb = "";
    sessionStorage.setItem("searchFiltersForm", JSON.stringify(options));
  }

  if (this.$route.path !== "/homepage") {
    router.push({ path: "/homepage" });
  } else {
    this.$router.go();
  }
}

export function redirectToLogin() {
  if (this.$route.path !== "/newlogin") {
    router.push({ path: "/newlogin" });
  }
}

export function redirectToRegistration() {
  if (this.$route.path !== "/register") {
    router.push({ path: "/register" });
  }
}

export function redirectToUConnect() {
  // this will automatically go to the search page,if they are logged in. if they aren't logged in, the page will automatically redirect to the log in page
  window.open(
    `${process.env.VUE_APP_UNIFI_AGENT}#/uconnect/search/results`,
    "_self"
  );
}

export function redirectToAgentLogin() {
  window.open(`${process.env.VUE_APP_UNIFI_AGENT}#/login`, "_self");
}



// WEBPACK FOOTER //
// ./src/helpers/routerHelper.js